export const PRO_APP_DOWNLOAD_URL_PER_COUNTRY = {
  FR: 'https://app-pro.onelink.me/LjAU/appproinstall',
  GB: 'https://app-pro.onelink.me/LjAU/appdownload',
};
